"use strict";
module.exports = {

  update_application_setting: 'Application setting has been updated successfully',

}
